import { i18n_config_default } from './chunk-EJ2TIXJU.mjs';

// src/helpers/factories/settings/taxesFactory.ts
var typesText = {
  ["fixed" /* FIXED */]: i18n_config_default.t(
    "settingsModule.taxesSettings.taxesTable.taxTypes.fixed"
  ),
  ["percent" /* PERCENT */]: i18n_config_default.t(
    "settingsModule.taxesSettings.taxesTable.taxTypes.percent"
  ),
  ["table" /* TABLE */]: i18n_config_default.t(
    "settingsModule.taxesSettings.taxesTable.taxTypes.table"
  ),
  ["volume" /* VOLUMETRIC */]: i18n_config_default.t(
    "settingsModule.taxesSettings.taxesTable.taxTypes.volumetric"
  )
};
var taxTypeToValue = {
  ["fixed" /* FIXED */]: 1,
  ["percent" /* PERCENT */]: 2,
  ["table" /* TABLE */]: 3,
  ["volume" /* VOLUMETRIC */]: 4
};
var valueToTaxType = {
  1: "fixed" /* FIXED */,
  2: "percent" /* PERCENT */,
  3: "table" /* TABLE */,
  4: "volume" /* VOLUMETRIC */
};
var taxTypeDropdownFactory = () => {
  const options = [
    { label: typesText["fixed" /* FIXED */], value: taxTypeToValue["fixed" /* FIXED */] },
    {
      label: typesText["percent" /* PERCENT */],
      value: taxTypeToValue["percent" /* PERCENT */]
    },
    { label: typesText["table" /* TABLE */], value: taxTypeToValue["table" /* TABLE */] },
    {
      label: typesText["volume" /* VOLUMETRIC */],
      value: taxTypeToValue["volume" /* VOLUMETRIC */]
    }
  ];
  return [options];
};
var unitsText = {
  ["ml" /* ML */]: i18n_config_default.t(
    "settingsModule.taxesSettings.taxesTable.unitTypes.ml"
  ),
  ["l" /* L */]: i18n_config_default.t(
    "settingsModule.taxesSettings.taxesTable.unitTypes.l"
  ),
  ["gal" /* GAL */]: i18n_config_default.t(
    "settingsModule.taxesSettings.taxesTable.unitTypes.gal"
  ),
  ["qt" /* QT */]: i18n_config_default.t(
    "settingsModule.taxesSettings.taxesTable.unitTypes.qt"
  ),
  ["pnt" /* PNT */]: i18n_config_default.t(
    "settingsModule.taxesSettings.taxesTable.unitTypes.pnt"
  ),
  ["flOz" /* FL_OZ */]: i18n_config_default.t(
    "settingsModule.taxesSettings.taxesTable.unitTypes.flOz"
  )
};
var unitToValue = {
  ["ml" /* ML */]: 1,
  ["l" /* L */]: 2,
  ["gal" /* GAL */]: 3,
  ["qt" /* QT */]: 4,
  ["pnt" /* PNT */]: 5,
  ["flOz" /* FL_OZ */]: 6
};
var valueToUnit = {
  1: "ml" /* ML */,
  2: "l" /* L */,
  3: "gal" /* GAL */,
  4: "qt" /* QT */,
  5: "pnt" /* PNT */,
  6: "flOz" /* FL_OZ */
};
var taxVolumeUnitDropdownFactory = (isMassUpdate = false) => {
  const options = [
    {
      label: unitsText["ml" /* ML */],
      value: unitToValue["ml" /* ML */]
    },
    {
      label: unitsText["l" /* L */],
      value: unitToValue["l" /* L */]
    },
    {
      label: unitsText["gal" /* GAL */],
      value: unitToValue["gal" /* GAL */]
    },
    {
      label: unitsText["qt" /* QT */],
      value: unitToValue["qt" /* QT */]
    },
    {
      label: unitsText["pnt" /* PNT */],
      value: unitToValue["pnt" /* PNT */]
    },
    {
      label: unitsText["flOz" /* FL_OZ */],
      value: unitToValue["flOz" /* FL_OZ */]
    }
  ];
  if (isMassUpdate) {
    return [
      [
        {
          label: i18n_config_default.t("commonTexts.noChanges"),
          value: -1
        }
      ],
      options
    ];
  }
  return [options];
};
var orderTypesText = {
  ["catering" /* CATERING */]: i18n_config_default.t(
    "settingsModule.registerModeSettings.general.orderTypes.catering"
  ),
  ["delivery" /* DELIVERY */]: i18n_config_default.t(
    "settingsModule.registerModeSettings.general.orderTypes.delivery"
  ),
  ["dine in" /* DINE_IN */]: i18n_config_default.t(
    "settingsModule.registerModeSettings.general.orderTypes.dineIn"
  ),
  ["to_go" /* TO_GO */]: i18n_config_default.t(
    "settingsModule.registerModeSettings.general.orderTypes.toGo"
  )
};

export { orderTypesText, taxTypeDropdownFactory, taxTypeToValue, taxVolumeUnitDropdownFactory, typesText, unitToValue, unitsText, valueToTaxType, valueToUnit };
